var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{model:{value:(_vm.isShown),callback:function ($$v) {_vm.isShown=$$v},expression:"isShown"}},[_c('BonusInfo',{on:{"close":function($event){_vm.isShown = !_vm.isShown}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }